import React, { useEffect } from "react";
import { useSession } from "../context/SessionContext";
import { useNavigate } from "react-router-dom";
import UsuariosRSTemplate from "../components/templates/UsuariosRSTemplate";

const UsuariosRS = () => {
    const { user } = useSession();
    const navigate = useNavigate();

    useEffect(() => {
        if (user && user.role !== "Admin" && user.role !== "HumanResources") {
            navigate("/dashboard");
        }
    }, [user, navigate]);

    if (!user || (user.role !== "Admin" && user.role !== "HumanResources")) {
        return null;
    }

    return(
        <UsuariosRSTemplate/>
    );
};

export default UsuariosRS;